/**
 * @version 1.0
 * @author xieyq
 * @createTime 2022/2/23
 * @updateTime 2022/2/23
 * @decription 担保编辑页面
 */
import MyTitle from '@/components/common/myTitle';
import InfoTitle from '@/components/common/InfoTitle';
import {Toast} from 'vant'
import {
    typeBqlb,
    typeTjrlx,
    typeAjlx,
    typeBqlx,
    typeFsccFsqj
} from '@/filters/index';
import validate from '@/utils/validator/validator';
import {
    bgdbsqsclRule,
    bgsqsclRule,
    sqsclRule,
    bgqszclRule,
    qszclRule,
    SfzmlclRule,
    zjlclRule,
    sqrxxRule, // 申请人信息
    bsqrxxRule, // 被申请人信息
    ccxsxxRule, // 财产线索信息
    lasltzsRule // 立案受理通知书
} from '@/utils/validator/rules';
import {
    // 获取担保信息
    getDbbgBbjbxx,
    // 提交变更担保
    commitBgdb,
    // 下一步变更担保
    nextStepBgdb,
} from '@/api/guarantee';
// 滑动操作单元格组件
import ccSwipeCellRightDelete from '@/components/common/swipe-cell-right-delete/index.vue';
// 申请人模块js
import sqr from './mixins/sqr.js';
// 被申请人模块js
import bsqr from './mixins/bsqr.js';
// 原告代理人模块js
import dlr from './mixins/dlr.js';
// 财产线索模块js
import ccxs from './mixins/ccxs.js';
// 上传材料
import sccl from './mixins/sccl.js';

export default {
    data() {
        return {
            // 担保id
            dbid: this.$route.query.dbid,
            basicData: {
                cFymc: '', // 申请法院
                cDbzt:'',//担保状态
                cBxgsmc: '', // 担保机构
                cBqlx: '', // 保全类型
                cBqlxText: '', // 保全类型
                cBqlb: '', // 保全类别
                cBqlbText: '', // 保全类别
                cFsqj: '', // 非诉期间
                cFsqjText: '', // 非诉期间
                nSqbqje: '', // 申请保全金额
                nDbfy: '', // 担保费用
                cFl: '', // 担保费率
                cTjr: '', // 提交人
                cTjrlx: '', // 提交人身份
                cTjrlxText: '', // 提交人身份
                cClerkNo:"",//咨询员编号
                dtCreatetime:'',
                dtTjsj:'',//提交日期
                cAyName:'',
                cAyxzxwName:'',
                cXzaymc:'',
            },
            formData: {
                cAh: '', // 案号
                cAy: '', // 案由
                nAjlx: '', // 案件类型
                nAjlxText: '',
                cAyName: ''
            },
            // 保存按钮是否可以点击
            saveBtnClickable: true,
            // 基本请求数据
            basicPostData: {},
            // 是否来自于申请变更
            fromSQBG: sessionStorage.getItem('fromSQBG') === 'true'
        }
    },
    computed: {
    },
    components: {
        ccSwipeCellRightDelete,
        MyTitle,
        InfoTitle
    },
    // 混入
    mixins: [sqr, bsqr, dlr, ccxs, sccl],
    // 依赖
    provide() {
        return {
            // 是否申请便跟
            fromSQBG: this.fromSQBG
        }
    },
    created() {
        // 初始化所有数据
        this.initAllData();
    },
    methods: {
        //案号案由提示
        toast(value){
            Toast(value);
        },

        /**
         * 初始化所有数据
         * @returns {void}
         * */
        initAllData: function () {
            // 如果是申请变更
            if(this.fromSQBG) {
                // 获取页面的基本信息
                getDbbgBbjbxx(this.dbid).then(res=>{
                    console.log('--getDbbgBbjbxx 111',res);
                    let {dbJbxx,dbSqrs,dbDsrs,dbDlrs,dbPropertys,scclVo} = res.data
                    // 初始化基本信息数据
                    this.initBasicData({data:dbJbxx});
                    // 初始化申请人数据
                    this.initSqrData(dbSqrs);
                    // 初始化被申请人数据
                    this.initBsqrData(dbDsrs);
                    // 初始化代理人数据
                    this.initDlrData(dbDlrs);
                    // 初始化财产线索数据
                    this.initCcxsData(dbPropertys);
                    // 初始化上传材料数据
                    this.initScclData(scclVo);
                }).catch(function (error) {
                    console.log('--catch 123');
                    console.log(error);
                });
            }else {
                // TODO 后续公用后需要加上其他的数据处理
            }

        },

        /**
         * 初始化基础数据
         * @returns {void}
         * */
        initBasicData: function (res) {
            // 赋值请求数据
            this.basicPostData = res.data;
            const dealRes=(res)=>{
                console.log('--init 000');
                let data = res.data;
                let {cAhNf, nAjlx} = data;
                const key = (Number(cAhNf) >= 2021) ? 2021 : 2020;
                console.log('--init basic',cAhNf,nAjlx,key);
                if (key === 2020) {
                    this.ayLabel_1 = Number(nAjlx) === 6 ? '案由(主体类型)' : '案由';
                    this.ayLabel_2 = '案由(行为种类)';
                } else {
                    this.ayLabel_1 = Number(nAjlx) === 6 ? '行政主体类型' : '案由';
                    this.ayLabel_2 = '行政案由';
                }


                this.basicData.cFymc = data.cFymc;
                this.basicData.cBxgsmc = data.cBxgsmc;
                this.basicData.cBqlx = data.cBqlx;
                this.basicData.cBqlxText = typeBqlx(data.cBqlx);
                this.basicData.cBqlb = data.cBqlb;
                this.basicData.cBqlbText = typeBqlb(data.cBqlb);
                this.basicData.nSqbqje = data.nSqbqje;
                this.basicData.nDbfy = data.nDbfy;
                this.basicData.cFl = data.cFl;
                this.basicData.cTjr = data.cTjr;
                this.basicData.cTjrlx = data.cTjrlx;
                this.basicData.cTjrlxText = typeTjrlx(data.cTjrlx);
                this.basicData.cClerkNo=data.cClerkNo||'--';
                this.formData.cAhNf = data.cAhNf;
                this.formData.cAh = `（${data.cAhNf}）${data.cAhFydz}${data.cAhAjlxdz}${data.cAhAjxh}号`;
                this.formData.cAy = data.cAy;
                this.formData.cXzaymc=data.cXzaymc;
                this.formData.nAjlx = data.nAjlx;
                this.formData.cDbzt = data.cDbzt
                this.formData.nAjlxText = typeAjlx(data.nAjlx);
                this.basicData.dtCreatetime = data.dtCreatetime;
                this.basicData.dtTjsj = data.dtTjsj||'--';
                this.basicData.cFsqj = data.cFsqj;
                this.basicData.cFsqjText = typeFsccFsqj(data.cFsqj);
                //初始化案由

                //var _this=this;
                if(nAjlx === 6){
                    //初始化案由
                    let cAyName = data.cAy.split(';')
                    this.formData.cAyName = cAyName.splice(0,1).join(';')
                    this.formData.cAyxzxwName = cAyName.join(';')
                }else{
                    this.formData.cAyName = data.cAy
                }
            }

            dealRes(res);

        },

        /**
         * 验证申请人
         * @returns {String} 校验警告信息
         * */
        verifySQR() {
            let result = '';
            // 遍历申请人列表，如果申请人类型为1 自然人 并且证件类型为1 身份证，如果证件有效期为空，则提示警告
            this.sqrDataList.some(sqrItem => {
                // 如果申请人类型为1 自然人 并且证件类型为1 身份证，如果证件有效期为空
                const _zjyxqFlag = (sqrItem.cSqrlx === '1' && sqrItem.cZjlx === '1') && (!sqrItem.dtZjyxqKsrq || !sqrItem.dtZjyxqJsrq);
                // 证件有效期和单位性质校验
                if(_zjyxqFlag){
                    result = `请完善申请人${sqrItem.cSqrxm}的信息`;
                    return true;
                }
                // 单位性质校验，不能为空
                const _dwxzFlag = (sqrItem.cSqrlx === '2' || sqrItem.cSqrlx === '3') && !sqrItem.cDwxz;
                if (_dwxzFlag) {
                    result = `请完善申请人${sqrItem.cQymc}的信息`;
                    return true;
                }
                return false;
            });
            return result;
        },

        /**
         * 获取参数选项
         * @returns {Object} 请求参数对象
         * */
        getParams() {
            return {
                // 新增/编辑
                // 基本信息
                dbJbxx:this.basicPostData,
                // 申请人
                tbSqr: this.sqrDataList,
                // 被申请人
                tbDsr: this.bsqrDataList,
                // 原告代理人
                tbDlr: this.dlrDataList,
                //财产线索
                tDbProperties: this.ccxsDataList,

                // 删除
                //申请人
                sqrIds: this.sqrDelIds,
                //被申请人
                dsrIds: this.bsqrDelIds,
                //原告代理人
                ygdlrIds: this.dlrDelIds,
                //财产线索
                ccxsIds: this.ccxsDelIds
            }
        },

        /**
         * 请求下一步
         * @returns {Promise} 请求对象
         * */
        requestNextStep() {
            return new Promise((resolve, reject) => {
                nextStepBgdb(this.dbid, this.getParams()).then(res => {
                    if (res.code === 500) {
                        reject(res.message);
                        return;
                    }
                    resolve();
                });
            })
        },

        /**
         * 点击提交
         * @returns {void}
         * */
        eClickSubmit() {
            this.validateFormData().then(() => {
                // 申请人校验
                const _sqrVerifyResult = this.verifySQR();
                if (_sqrVerifyResult) {
                    this.$notify(_sqrVerifyResult);
                    return;
                }
                // 校验材料信息
                this.validateClxx().then(() => {
                    // 先调用下一步接口，再进行提交操作
                    this.requestNextStep().then(() => {
                        // 调用提交接口
                        commitBgdb(this.dbid).then(res=>{
                            if (res.code === 200) {
                                this.$notify({'type': 'success', 'message': '提交成功'});
                                // 跳转到担保列表
                                this.$router.push('/home/myGuarantee');
                            } else {
                                this.$notify(res.message);
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    }).catch(err => {
                        this.$notify(err);
                    });
                });
            });
        },

        /**
         * 校验表单数据
         * @returns {Promise} 校验promise对象
         * */
        validateFormData: function () {
            let descriptor = {
                // 申请人校验
                sqrData: sqrxxRule,
                // 被申请人校验
                bsqrData: bsqrxxRule,
                // 财产线索校验
                ccxsData: ccxsxxRule
            };
            const data = {
                // 申请人
                sqrData: this.sqrDataList,
                // 被申请人
                bsqrData: this.bsqrDataList,
                // 财产线索
                ccxsData: this.ccxsDataList,
            };
            return validate(descriptor, data);
        },

        /**
         * 校验材料信息
         * @returns {Promise} 校验promise对象
         * */
        validateClxx: function () {
            let descriptor={};
            if(this.fromSQBG) {
                // 变更担保申请书
                descriptor.bgdbsqs = bgdbsqsclRule;
                // 申请书
                descriptor.sqs = bgsqsclRule;
            }else{
                // 申请书
                descriptor.sqs = sqsclRule;
            }
            // 身份证明类材料
            descriptor.sfzml = new SfzmlclRule(true);
            // 证据类材料
            descriptor.zjl = zjlclRule;

            if (this.basicData.cBqlb === '2') {
                // 诉讼保全时立案受理通知书必填
                // 起诉书
                descriptor.qsz = this.fromSQBG ?bgqszclRule:qszclRule;
                // 立案受理通知书
                descriptor.lasltzs = lasltzsRule;
            }

            // 校验上传材料数据
            return validate(descriptor, this.scclData);
        },

        /**
         * TODO 暂存方法因为申请变更不涉及暂存，所以这块逻辑暂时不动，到时候再处理~
         * @returns {void}
         * */
        temporaryStorageDb() {
            console.log('--暂存 123',this.formData.cDbzt);
            if(this.formData.cDbzt==='1'){
                this.$notify({'type': 'success', 'message': '暂存成功'});
            }else if(this.formData.cDbzt==='6'){
                this.$notify('您未修改任何信息，无需暂存');
            }else{
                this.$notify('此担保已经提交过了，无需再次暂存');
            }

            this.saveBtnClickable = true;
        }
    }
}
